import MainLayout from "../components/Layouts/MainLayout";
import BlocksTable from "../components/blocksTable";

export default function BlocksPage() {
  return (
    <MainLayout activeId="blocks" isRoomView={true}>
      <BlocksTable />
    </MainLayout>
  );
}
